<template>
    <el-dialog
        title="练习题"
        :visible.sync="dialogVisible"
        width="600px"
        :before-close="handleClose">
        <div
            v-for="(item, index) in questions"
            :key="index"
            v-if="currentPage==index+1">
            <div style="font-size: 18px;">{{index+1}}.
                {{item.title}}</div>
            <div style="font-size: 16px; margin-top: 10px;">{{item.text}}</div>
            <div v-if="item.textPic" style="margin:20px 0 0 0; text-align: center;">
                <img :src="item.textPic" alt="加载失败" style="width: 250px;"></img>
            </div>
            <div>
                <el-radio-group v-model="radio" style="margin: 20px auto;">
                    <el-radio
                        v-for="(subItem, subIndex) in item.answer"
                        :key="subIndex"
                        :label="subIndex"
                        style="width: 100%; margin: 15px auto; display: flex;white-space: normal;line-height:20px;">
                        <div style="display: flex;">
                            <div style="margin-right: 5px;">{{alpha[subIndex]}}.</div>
                            <div v-if="subItem.imgText.length > 0 && subItem.imgSrc.length > 0" style="display:flex; flex-direction:column;align-items:center">
                                <img :src="subItem.imgSrc" alt="加载失败" width="80px">
                                    <div>{{subItem.imgText}}</div>
                                </div>
                                <div v-if="subItem.imgSrc.length > 0 && subItem.imgText.length == 0">
                                    <img :src="subItem.imgSrc" alt="加载失败" width="100px"></div>
                                    <div v-if="subItem.imgText.length > 0 && subItem.imgSrc.length == 0" style="width:100%">
                                        {{subItem.imgText}}
                                    </div>
                                </div>
                            </el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <el-pagination
                    style="position: absolute;bottom:0;left:50%;transform: translate(-50%, -50%);"
                    background="background"
                    layout="prev, pager, next"
                    :page-size="1"
                    :page-count="5"
                    @current-change="handleCurrentChange"
                    :total="questions.length"></el-pagination>
            </el-dialog>

        </template>

        <script>
            import data from '../../data/questions.json'
            export default {
                name: "test",
                data() {
                    return {
                        dialogVisible: false,
                        node: {},
                        alpha: [
                            "A", "B", "C", "D"
                        ],
                        questions: [],
                        currentPage: 1,
                        radio: ""
                    }
                },
                methods: {
                    getNodeInfo(res) {
                        this.dialogVisible = true;
                        this.node = res;
                        for (let i = 0; i < data.length; i++) {
                            if (data[i].id == this.node.id) {
                                this.questions = data[i].questions
                            }
                        }
                    },
                    handleCurrentChange(page) {
                        this.currentPage = page;
                        this.radio = ""
                    },
                    handleClose() {
                        this.dialogVisible = false;
                        this.radio = "";
                        this.currentPage = 1
                    }
                }
            }
        </script>

        <style>
            .el-dialog {
                height: 600px;
            }
            .el-radio__label {
                font-size: 16px;
            }
        </style>


// WEBPACK FOOTER //
// src/components/subComponents/test.vue